import { Component, inject, input } from '@angular/core';
import { MatIcon } from "@angular/material/icon";
import { StationLongDto } from '@api/rest';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-contact-detail',
  imports: [MatIcon],
  templateUrl: './contact-detail.component.html',
  styleUrl: './contact-detail.component.scss',
})
export class ContactDetailComponent {
  protected readonly translate = inject(TranslateService);
  protected readonly contact = input<StationLongDto | undefined>(undefined);
}
